import msalInstance from "../msalinstance";
import { silentRequest } from "../auth-config";

export const getAccessToken = async () => {
  const account = msalInstance.getActiveAccount();
  if (!account) {
    throw new Error("No active account");
  }

  const response = await msalInstance.acquireTokenSilent({
    ...silentRequest,
    account,
  });

  return response.accessToken;
};
